import { gql } from 'graphql-request'
import { useMutation } from '@/proxy/react-query'
import { client } from '@/proxy/client'
import { MutationDataError } from '@/resources/types'

interface ISellerSaveContractResponse {
  savePocContract: {
    success: boolean
  }
}

type SellerSaveContractInput = {
  contractId: string
}

export const SAVE_POC_CONTRACT = gql`
  mutation sellerSavePocContract($contractId: String!) {
    savePocContract(contractId: $contractId) {
      success
    }
  }
`

export const useSellerSaveContract = () =>
  useMutation<
    ISellerSaveContractResponse,
    MutationDataError,
    SellerSaveContractInput
  >({
    mutationFn: variables =>
      client.request<ISellerSaveContractResponse, SellerSaveContractInput>(
        SAVE_POC_CONTRACT,
        variables
      ),
  })
